import { Link } from 'react-router-dom';
import top_image from '../images/top_image.png';

export const Top = () => {
    return (
        <div className='flex flex-col min-h-screen'>
                <main className='flex justify-center h-full w-full relative flex-grow'>
                    <img src={top_image} alt="TOP画像" className='object-cover w-full h-auto'/>
                    <div className='absolute justify-center pt-10 text-white text-xl iPhone5/SE:text-xl md:text-3xl lg:text-4xl font-serif tracking-wider md:tracking-widest' style={{writingMode: 'vertical-lr'}}>あなたの心を綴じる<span className='absolute left-1/2 pb-20 bg-white iPhone5/SE:w-1px w-0.5 iPhone5/SE:h-2/6 h-2/6'></span></div>
                    <div className="absolute text-center pb-1 font-bold text-white text-xl iPhone5/SE:text-xl font-serif iPhone5/SE:bottom-20 bottom-28 iPad/iPadMini:w-full w-full">初回限定製本1冊700円</div>
                    <Link to="/input-note-link" className='absolute justify-center iPhone5/SE:bottom-5 bottom-10'>
                        <button className='iPhone5/SE:w-72 w-80 h-16 text-black bg-white bg-opacity-90 font-serif rounded border border-black hover:bg-black hover:text-white'>本を作りはじめる</button>
                    </Link>
                </main>
        </div>
    );
};